module.exports = __webpack_public_path__ + "static/media/Eb2.24fc9ccd.mp3";